// Sample questions for the #questions-demo page, asked by backend core/questions on a sample trip
// (Tokyo 3 + Kyoto 3, vegetarian, been before, asked for "Gion" and Dotonbori), then a saved Kyoto food guide.
// Generated by backend/scripts/questions_demo.py — do not edit by hand.
const QUESTIONS_DEMO = [
 {
  "key": "away:dotonbori glico sign",
  "kind": "other_city",
  "ask": "Dotonbori Glico Sign is in Osaka — and Osaka isn't on your trip. What should we do?",
  "why": "Osaka is less than an hour by train from Kyoto.",
  "advice": "Easy to add: even one day in Osaka gives you Dotonbori Glico Sign at its best hour, without rushing.",
  "options": [
   {
    "value": "add_city",
    "label": "Add Osaka to my trip",
    "hint": "We'll take you back to your cities",
    "recommended": false
   },
   {
    "value": "leave_out",
    "label": "Leave it out this time",
    "hint": "",
    "recommended": false
   }
  ],
  "default": "leave_out",
  "if_skipped": "We leave Dotonbori Glico Sign out and tell you in the plan.",
  "multi": false,
  "free_text": "",
  "priority": 15,
  "subject": {
   "city": "Osaka",
   "place": "Dotonbori Glico Sign"
  }
 },
 {
  "key": "which:gion",
  "kind": "which_place",
  "ask": "“Gion” — which one did you mean?",
  "why": "We want to plan the exact place you have in mind, at its best hour — and a near miss sends you somewhere else.",
  "advice": "Pick the one you meant, or tell us it's something else.",
  "options": [
   {
    "value": "Gion Corner",
    "label": "Gion Corner",
    "hint": "Seven traditional arts in fifty minutes · Higashiyama",
    "recommended": false
   },
   {
    "value": "Gion District",
    "label": "Gion District",
    "hint": "Kyoto's old entertainment quarter · Higashiyama",
    "recommended": false
   },
   {
    "value": "Gion Duck Noodles — Gion",
    "label": "Gion Duck Noodles — Gion",
    "hint": "Eight seats in a Gion alley for duck ramen · Higashiyama",
    "recommended": false
   },
   {
    "value": "__other__",
    "label": "Something else",
    "hint": "Keep my words — look it up for me",
    "recommended": false
   }
  ],
  "default": "__other__",
  "if_skipped": "We keep “Gion” as you wrote it and look it up.",
  "multi": false,
  "free_text": "Or type it another way",
  "priority": 20,
  "subject": {}
 },
 {
  "key": "base:kyoto",
  "kind": "base",
  "ask": "Where are you staying in Kyoto?",
  "why": "Your mornings start and your evenings end where you sleep: we put breakfast, the last dinner and the way home near it.",
  "advice": "A neighbourhood is enough. Our pick: downtown, by Shijo–Kawaramachi — you walk to Gion for dinner and every bus starts there.",
  "options": [
   {
    "value": "Kyoto Station",
    "label": "Kyoto Station",
    "hint": "Easiest with luggage and day trips",
    "recommended": false
   },
   {
    "value": "Shijo Kawaramachi",
    "label": "Downtown (Shijo–Kawaramachi)",
    "hint": "Walk to Gion and dinner",
    "recommended": true
   },
   {
    "value": "Gion",
    "label": "Gion / Higashiyama",
    "hint": "Temples at your door, quiet at night",
    "recommended": false
   },
   {
    "value": "undecided",
    "label": "Not decided yet",
    "hint": "",
    "recommended": false
   }
  ],
  "default": "undecided",
  "if_skipped": "We plan Kyoto from its centre and you can tell us later.",
  "multi": false,
  "free_text": "Hotel name or area",
  "priority": 40,
  "subject": {}
 },
 {
  "key": "diet:vegetarian",
  "kind": "vegetarian",
  "ask": "How strict is vegetarian for you?",
  "why": "In Japan most broths and sauces are made with fish stock (dashi) — even a plain udon or a miso soup.",
  "advice": "If fish stock is a no, tell us: we only seat you where the kitchen can do without it.",
  "options": [
   {
    "value": "strict",
    "label": "Strict — no fish stock either",
    "hint": "",
    "recommended": false
   },
   {
    "value": "flexible",
    "label": "No meat or fish on the plate; stock is fine",
    "hint": "",
    "recommended": false
   }
  ],
  "default": "strict",
  "if_skipped": "We play it safe: no fish stock.",
  "multi": false,
  "free_text": "",
  "priority": 45,
  "subject": {}
 },
 {
  "key": "seen",
  "kind": "already_seen",
  "ask": "You've been before — anything you've already seen?",
  "why": "We'd rather spend your days on what you don't know yet than send you back to the classics.",
  "advice": "Tick what you've done. Anything you want to see again, leave unticked.",
  "options": [
   {
    "value": "Bamboo Forest",
    "label": "Bamboo Forest",
    "hint": "Arashiyama, Kyoto",
    "recommended": false
   },
   {
    "value": "Fushimi Inari Taisha",
    "label": "Fushimi Inari Taisha",
    "hint": "Fushimi, Kyoto",
    "recommended": false
   },
   {
    "value": "Gion District",
    "label": "Gion District",
    "hint": "Higashiyama, Kyoto",
    "recommended": false
   },
   {
    "value": "Imperial Palace",
    "label": "Imperial Palace",
    "hint": "Kyoto Imperial Palace area, Kyoto",
    "recommended": false
   },
   {
    "value": "Kinkakuji",
    "label": "Kinkakuji",
    "hint": "Kita Ward, Kyoto",
    "recommended": false
   },
   {
    "value": "Kiyomizu-dera",
    "label": "Kiyomizu-dera",
    "hint": "Higashiyama, Kyoto",
    "recommended": false
   },
   {
    "value": "Nara",
    "label": "Nara",
    "hint": "Nara Park, Nara, Kyoto",
    "recommended": false
   },
   {
    "value": "Nijo Castle",
    "label": "Nijo Castle",
    "hint": "Nakagyo, Kyoto",
    "recommended": false
   },
   {
    "value": "Philosopher's Path",
    "label": "Philosopher's Path",
    "hint": "Sakyo, Kyoto",
    "recommended": false
   },
   {
    "value": "Ryoan-ji",
    "label": "Ryoan-ji",
    "hint": "Kita Ward, Kyoto",
    "recommended": false
   },
   {
    "value": "Uji & Byodo-in",
    "label": "Uji & Byodo-in",
    "hint": "Uji, Kyoto, Kyoto",
    "recommended": false
   },
   {
    "value": "Yasaka Shrine",
    "label": "Yasaka Shrine",
    "hint": "Higashiyama, Kyoto",
    "recommended": false
   }
  ],
  "default": "",
  "if_skipped": "We keep the classics in play.",
  "multi": true,
  "free_text": "",
  "priority": 55,
  "subject": {}
 },
 {
  "key": "source:pick",
  "kind": "source_pick",
  "ask": "Any of these you can't miss?",
  "why": "We read this page as: A food lover's two days in Kyoto. It names 3 places on your trip. 1 are in Osaka, not on your trip, so we leave those out.",
  "advice": "Tick the ones you can't miss: we guarantee those. The rest stay as ideas we use when they fit.",
  "options": [
   {
    "value": "Nishiki Market",
    "label": "Nishiki Market",
    "hint": "Kyoto",
    "recommended": false
   },
   {
    "value": "Pontocho",
    "label": "Pontocho",
    "hint": "Kyoto",
    "recommended": false
   },
   {
    "value": "Kiyomizu-dera",
    "label": "Kiyomizu-dera",
    "hint": "Kyoto",
    "recommended": false
   }
  ],
  "default": "",
  "if_skipped": "They all stay as ideas, used when they fit.",
  "multi": true,
  "free_text": "",
  "priority": 50,
  "subject": {}
 }
];

export default QUESTIONS_DEMO;
